import appointTable from "./commonModel/allAppointmentTable.vue";
import addAppointment from './commonModel/addAppointment.vue';
import * as requestApi from '../../../../utils/appointment.url';

// set A element

const setAelement = () => {
  setTimeout(() => {
    const elPager = document.querySelector('.el-pager');
    const liList = Array.from(elPager.querySelectorAll('li'));
    liList.forEach(li => {
      if (!li.querySelector('a')) {
        let oldInner = li.innerHTML;
        li.innerHTML = `<a href="javascript:void(0)">${oldInner}</a>`
      }
    })
  }, 300);
}
export default {
  name: "myAppointMent",
  components: {
    appointTable,
    addAppointment
  },
  data() {
    return {
      rsStatus: '', //预约状态： 0预约待办、1预约已办、2已取消/已过期
      pageRowNum: 10,
      pageIndex: 1,
      activeName: "first",
      appointmentVisible: false,
      bsSeq: '', //业务主键
      seq: '', //预约主键
      itemInfo: {},
      tabList: [], //全部预约 
      pageObj: {},
      isTel: false
    }
  },
  methods: {
    goAppointment() {
      this.getAreaSeq().then(res => {
        if (Number(res.status) === 200) {
          let areaSeq = res.data.value;
          this.$router.push({
            path: '/index',
            query: {
              areaSeq: areaSeq
            }
          })
        } else {
          this.$message.error('获取地区编码失败');
        }
      });
    },
    goPhoneAppointment(){
      this.getAreaSeq().then(res => {
        if (Number(res.status) === 200) {
          let areaSeq = res.data.value;
          this.$router.push({
            path: '/phoneAppointment',
            query: {
              areaSeq: areaSeq
            }
          })
        } else {
          this.$message.error('获取地区编码失败');
        }
      });
    },
    getAreaSeq(){
      return requestApi.interOutnetConfig({
        key: 'YY_AREA_SEQ'
      }, 'get');
    },
    // 预约改期刷新页面
    changeAppointment() {
      this.handleClick();
    },
    //tabs切换
    handleClick() {
      console.log(this.activeName);
      if (this.activeName == 'first') {
        this.rsStatus = '';
      } else if (this.activeName == 'wait') {
        this.rsStatus = 0;
      } else if (this.activeName == 'complete') {
        this.rsStatus = 1;
      } else if (this.activeName == 'third') {
        this.rsStatus = 2;
      } else {

      }
      this.myAppointmentList(this.rsStatus);
    },
    //页码更新列表数据
    changePage(val) {
      console.log(1111);
      this.myAppointmentList(this.rsStatus, 10, val)
    },
    // 预约列表
    myAppointmentList(rsStatus = '', pageRowNum = 10, pageIndex = 1) {
      requestApi.myAppointmentList({
        rsStatus: rsStatus,
        pageRowNum: pageRowNum,
        pageIndex: pageIndex,
        reserveSrc: 0, // 预约渠道 0、PC端自主预约；
      }, 'get').then(res => {
        if (Number(res.status) === 200) {
          this.tabList = res.data.dataList;
          this.pageObj = res.data.pageObj;
          setAelement();
        }
      }).catch(err => {
        console.log(err);
      });
    },
    // 预约改期
    openAppointment(val) {
      this.appointmentVisible = true;
      this.itemInfo = val
    },
    // 取消预约
    cancleAppointment(val) {
      console.log('val-', val)
      requestApi.cancleAppointment({
        seq: val
      }, 'get').then(res => {
        if (Number(res.status) === 200) {
          this.$message.success(res.desc);
          this.handleClick();
        } else {
          this.$message.error(res.desc)
        }
      }).catch(err => {
        console.log(err);
      });
    },
    //删除预约
    delAppointment(val) {
      console.log('val-', val)
      requestApi.delAppointment({
        seq: val,
      }, 'get').then(res => {
        if (Number(res.status) === 200) {
          this.$message.success(res.desc);
          this.handleClick();
        } else {
          this.$message.error(res.desc)
        }
      }).catch(err => {
        console.log(err);
      });
    },

  },
  mounted() {
    this.myAppointmentList();
    this.isTel = parseInt(sessionStorage.getItem('ORDER_TEL_KEY'));
  },
  created() {}
};